/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthenticationDto } from '../../models/authentication-dto';
import { RedirectDataDto } from '../../models/redirect-data-dto';

export interface AuthSsoAndAuthorizationInit$Params {
  'x-trace-id'?: string;
  code: string;
}

export function authSsoAndAuthorizationInit(http: HttpClient, rootUrl: string, params: AuthSsoAndAuthorizationInit$Params, context?: HttpContext): Observable<StrictHttpResponse<(AuthenticationDto | RedirectDataDto)>> {
  const rb = new RequestBuilder(rootUrl, authSsoAndAuthorizationInit.PATH, 'get');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.query('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(AuthenticationDto | RedirectDataDto)>;
    })
  );
}

authSsoAndAuthorizationInit.PATH = '/api/auth/init';
